import * as React from "react";
import { BlankLink } from "src/components/BlankLink/BlankLink";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ZAttrValue } from "../ZAttrValue";
import { ZAttrViewLink } from "./ZAttrViewComponent";

type PropsAttrViewLink = {
  component: ZAttrViewLink;
  value: ZAttrValue;
};

export const AttrViewLink: React.FC<PropsAttrViewLink> = (props) => {
  const { value, component } = props;
  if (value.type === "string") {
    return value.value;
  }
  if (value.type !== "strOption" || !value.value) {
    return null;
  }
  const { id, label } = value.value;

  const { role } = component;
  let url: string | undefined;
  switch (role) {
    case "record":
      url = makeUrl(PageUrl.editRecord, { id });
      break;
    case "class":
      url = makeUrl(PageUrl.class, { id });
      break;
    default:
      break;
  }
  if (!url) return label;
  return (
    <BlankLink href={url} color="primary-orange">
      {label}
    </BlankLink>
  );
};
